import { Box, Grid, Paper, Typography} from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getVendorBookings } from "services/vendorDashboard";
import '@inovua/reactdatagrid-community/index.css'
import ReactDataGrid from "@inovua/reactdatagrid-community";
import { getDbFormat, tConvert, getBookingStatus } from "utils/common";


const defaultFilterValue = [
  { name: 'booking', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
      if(filterValue === null){
        return true;
      };
      const { bookingId, fromDate, fromTime, seatIds } = data || {};

      return (
        bookingId?.toLowerCase()?.includes(filterValue.toLowerCase())
        || bookingId?.toLowerCase()?.includes(filterValue.toLowerCase())
        || fromDate?.toLowerCase()?.includes(filterValue.toLowerCase())
        || tConvert(fromTime)?.toLowerCase()?.includes(filterValue.toLowerCase())
        || (seatIds || []).join(', ').toLowerCase()?.includes(filterValue.toLowerCase())
      );
    }
  },
  { name: 'payment', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
    if(filterValue === null){
      return true;
    };
    const { transactionId, paymentChannel } = data?.bookingTransaction || {};
    return (transactionId?.toLowerCase()?.includes(filterValue.toLowerCase())
      || paymentChannel.toLowerCase()?.includes(filterValue.toLowerCase())
    );
  }},
  { name: 'lib_deatils', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
    if(filterValue === null){
      return true;
    };
    const { address, name } = data?.library || {};
    const addressArr= [];
    addressArr.push(address?.area);
    addressArr.push(address?.city);
    addressArr.push(address?.state);
    addressArr.push(address?.country);
    addressArr.push(address?.pin);
    const addressStr = (addressArr.filter((ele)=> !!ele ).join(', ') || ''); 

    return (addressStr.toLowerCase().includes(filterValue.toLowerCase())
      || name.toLowerCase().includes(filterValue.toLowerCase())
    );
  }},
  { name: 'cust', operator: 'contains', type: 'string', value: '', fn: ({ value, filterValue, data }) => {
    if(filterValue === null){
      return true;
    };
    const { displayName, mobile, email } = data?.user || {};
    return displayName?.toLowerCase()?.includes(filterValue.toLowerCase()) || mobile?.toLowerCase()?.includes(filterValue.toLowerCase()) || email?.toLowerCase()?.includes(filterValue.toLowerCase());
  }},
];

export default function VendorBookings({pageFilters}) {
  
  const [, setGridRef] = useState(null);
  
  const { enqueueSnackbar } = useSnackbar();
  const [bookings, setBookings] = useState([]);
  const gridStyle = useMemo(() => ({ height:( bookings.length > 0 ? bookings.length * 56.2 :  500), width: 'auto', maxHeight: '70vh'}), [bookings]);

  const getLabelAndValueFormat = (label, value) => {
    return (
      <Box>
        <Typography variant="subtitle2" component="span">{label}: </Typography>
        <Typography variant="body2" component="span">
        {value}
        </Typography>
      </Box>
    )
  }

  const columns = useMemo(() => ([
    { name: 'booking', header: 'Booking Details', width: 320, render: ({data} ) => {
      return (
      <>
        {data?.bookingId ? getLabelAndValueFormat('Booking No', data?.bookingId): null}
        {data?.fromTime ? getLabelAndValueFormat('Timing', tConvert(data?.fromTime)): null}
        {data?.fromDate ? getLabelAndValueFormat('Date', data?.fromDate): null}
        {data?.seatCount ? getLabelAndValueFormat('Total Seats', data?.seatCount): null}
        {data?.seatIds?.length > 0 ? getLabelAndValueFormat('Seat No', data?.seatIds.join(',')): null}
      </>);
    }},
    { name: 'payment', header: 'Payment', width: 260, render: ({data} ) => {
      return (
        <>
          {data?.bookingTransaction?.paymentChannel ? getLabelAndValueFormat('Type', data?.bookingTransaction?.paymentChannel): null}
          {data?.bookingTransaction?.transactionId ? getLabelAndValueFormat('TxnId', data?.bookingTransaction?.transactionId): null}
        </>
      )
    }},
    { name: 'lib_deatils', header: 'Library Details', width: 260, render: ({data} ) => data?.library?.name || ''},
    { name: 'cust', header: 'Customer Details', width: 280, render: ({data} ) => { 
      return (
        <>
          {data?.user?.userId ? getLabelAndValueFormat('CustId', data?.user?.userId): null}
          {data?.user?.firstName ? getLabelAndValueFormat('Name', data?.user?.firstName): null}
          {data?.user?.mobile ? getLabelAndValueFormat('Mobile', data?.user?.mobile): null}
        </>
      ); 
    }},
    { name: 'amount', header: 'Amount', width: 120, render: ({data}) => data?.bookingTransaction?.amount},
    { name: 'status', header: 'Status', width: 160, render: ({data}) => getBookingStatus(data)},
    { name: 'createdOn', header: 'Created On', width: 180 },
  ]),[]);

  const getBookings = useCallback((pageFilters) => {
    const [from, to ]= pageFilters.filterDates;
    const data = {
      from: getDbFormat(from), to: getDbFormat(to), propertyId: pageFilters.library.id, propertyType: 'LIBRARY'
    };

    getVendorBookings(data).then(({response, error}) => {
      if(response){
        setBookings(response);
      } else {
        setBookings([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(pageFilters){
      getBookings(pageFilters);
    }
  }, [getBookings, pageFilters]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate >
        <Grid container columnSpacing={4} rowSpacing={2} >
          <Grid item xs={12} sm={12} md={12} lg={12} >
              <Box component="div" sx={{  maxHeight: 720, width: '100%' }}>
                <ReactDataGrid
                  handle={setGridRef}
                  // idProperty="index"
                  style={gridStyle}
                  defaultFilterValue={defaultFilterValue}
                  columns={columns}
                  dataSource={bookings}
                  rowHeight={null} 
                  minRowHeight={50}
                  showColumnMenuTool={false} 
                />
              </Box>
            </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
